import Elements from './elements';
import LoadingScreen from './loading-screen';

var DOC = document;

var __Form = {

	elements: [],

	instances: [],

};

var FormInitializer = function (el, options) {

	let b = 0;

	var __obj;

	const CORE = {

		message: {

			elements: null,

			hidden: false,

			set: function (content, type) {
				var els = CORE.message.elements;
				var i = 0;
				var $el;

				if (els === null) {
					return false;
				}
				type = typeof type === 'string' ? type : 'error';
				content = typeof content === 'string' ? content : '';

				for (i; i < els.length; i++) {
					$el = $(els[i]);
					$el.removeClass([options.classNames.message + '--error', options.classNames.message + '--success']);

					if (type === 'success') {
						$el.addClass(options.classNames.message + '--success');

					} else {
						$el.addClass(options.classNames.message + '--error');

					}
					els[i].innerHTML = content;
				}

				return true;
			},

			toggle: function () {
				var els = CORE.message.elements;

				if (els === null) {
					return;
				}

				if (CORE.message.hidden) {
					$(els).show();
					CORE.message.hidden = false;
					return;
				}

				$(els).hide();
				CORE.message.hidden = true;
			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.message);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				CORE.message.elements = [];

				for (i; i < els.length; i++) {
					CORE.message.elements[CORE.message.elements.length] = els[i];
				}

			}

		},

		onDone: function (r) {

			if (r.error == 1) {
				LoadingScreen.hide();
				CORE.message.set(r.content, 'error');
				CORE.message.toggle();

				if ('onDone' in options && typeof options.onDone === 'function') {
					options.onDone(el, r, options);
				}
				return;
			}

			if (!options.reloadOnDone) {
				LoadingScreen.hide();
				CORE.message.set(r.content, 'success');
				CORE.message.toggle();

				if (options.resetFormOnSuccess) {
					el.reset();
				}

				if ('onDone' in options && typeof options.onDone === 'function') {
					options.onDone(el, r, options);
				}
				return;
			}
			DOC.location.reload(true);

		},

		onSubmit: function (e) {
			var FormDt = new FormData(this);

			e.preventDefault();
			// e.stopImmediatePropagation();

			LoadingScreen.show();
			CORE.message.set('');
			CORE.message.toggle();

			FormDt.append('action', options.action);

			if ('beforePost' in options && typeof options.beforePost === 'function') {
				options.beforePost(FormDt);
			}

			$.ajax({
				method: 'POST',
				url: options.url,
				dataType: 'json',
				processData: false,
				contentType: false,
				data: FormDt
			}).done(CORE.onDone);

		},

		destroy: function () {
			el.removeEventListener('submit', CORE.onSubmit);
		}

	};

	if (__Form.elements.length) {
		for (b; b < __Form.elements.length; b++){
			if (__Form.elements[b] === el) {
				return false;
			}
		}
	}

	CORE.message.construct();
	el.addEventListener('submit', CORE.onSubmit);

	__Form.elements[__Form.elements.length] = el;
	// __Form.instances[__Form.instances.length] = __obj;

	return {
		destroy: CORE.destroy
	};
}

var Form = function (options) {

	var parentNode = DOC;

	const CORE = {

		instances: null,

		refresh: function () {
			return CORE.reload();
		},

		reload: function () {
			CORE.destroy();
			return Form(options);

		},

		destroy: function () {
			const instances = CORE.instances;
			let i = 0;

			if (instances === null || !instances.length || instances[0] === false) {
				return;
			}

			for (i; i < instances.length; i++){
				instances[i].destroy();
			}

		},

		construct: function () {

			if ('element' in options && typeof options.element === 'object' && options.element !== null && 'nodeName' in options.element && options.element.nodeName === 'FORM') {
				CORE.instances = [];
				CORE.instances[CORE.instances.length] = FormInitializer(options.element, options);

				return;
			}

			CORE.instances = [];

			Elements({
				selector: options.classNames.form,
				element: parentNode,
				onElement: function (el) {
					CORE.instances[CORE.instances.length] = FormInitializer(el, options);
				}
			});

		}
	};

	if (typeof options !== 'object' || options == null) {
		return;
	}

	if (!('action' in options) || !('classNames' in options) || typeof options.classNames !== 'object') {
		return;
	}

	if (!('message' in options.classNames) || !('form' in options.classNames)) {
		return;
	}

	if (typeof options.classNames.message !== 'string' || typeof options.classNames.form !== 'string') {
		return;
	}

	if (!('reloadOnDone' in options) || typeof options.reloadOnDone !== 'boolean') {
		options.reloadOnDone = true;
	}

	if (!('resetFormOnSuccess' in options) || typeof options.resetFormOnSuccess !== 'boolean') {
		options.resetFormOnSuccess = false;
	}

	if ('parentNode' in options && typeof options.parentNode === 'object' && options.parentNode !== null && 'nodeName' in options.parentNode) {
		parentNode = options.parentNode;
	}
	options.url = 'url' in options && typeof options.url === 'string' ? options.url : '/ajax/form.php';

	CORE.construct();

	return {

		destroy: CORE.destroy,

		reload: CORE.reload,

		refresh: CORE.refresh,
	};

}

export default Form;